export const environment = {
  production: true,
  recaptchaSiteKey: '6LfGGLsZAAAAAIOz9R4pvFRtEyKG1bV42PsbB1Ct',
  apiUrl: '//testapi.elshaddaihomeschools.com/',
  schoolURL: '//testschool.elshaddaihomeschools.com/',
  tag: 'test',
};
